import * as angular from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ActionReasonsAlertsService} from "./action-reasons-alerts.service";
import {ActionReasonsRequestsService} from "./action-reasons-requests.service";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import {ActionReasonModel} from "../models/action-reason.model";
import {ActionReasonVisibilityEnum} from "../enums/action-reason-visibility.enum";
import {ActionReasonEntityEnum} from "../enums/action-reason-entity.enum";
import {ActionReasonEnum} from "../enums/action-reason.enum";
import {TaskStatusType} from "../../tasks/types/taskStatus.type";

export class ActionReasonsServiceService {

  constructor(private actionReasonsRequestsService: ActionReasonsRequestsService, private actionReasonsAlertsService: ActionReasonsAlertsService,
              private bringozLoaderService: BringozLoaderService, private $log, private confirmDialogService: ConfirmDialogService, private $q) {
  }

  getActionReasons(
    visibility?: ActionReasonVisibilityEnum[],
    entityTypes?: ActionReasonEntityEnum[],
    reasonTypes?: ActionReasonEnum[],
    pickupStatuses?: TaskStatusType[],
    dropoffStatuses?: TaskStatusType[],
    operationStatuses?: TaskStatusType[]
  ) {
    const deferred = this.$q.defer();

    this.actionReasonsRequestsService.getActionReasons(visibility, entityTypes, reasonTypes, pickupStatuses, dropoffStatuses, operationStatuses)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })

    return deferred.promise;
  }

  createActionReason(actionReason: ActionReasonModel) {
    const deferred = this.$q.defer();

    this.actionReasonsRequestsService.createActionReason(actionReason)
      .then((res) => {
        this.actionReasonsAlertsService.createSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.actionReasonsAlertsService.createError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateActionReason(updatedActionReason: ActionReasonModel) {
    const deferred = this.$q.defer();

    this.actionReasonsRequestsService.updateActionReason(updatedActionReason)
      .then((res) => {
        this.actionReasonsAlertsService.updateSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.actionReasonsAlertsService.updateError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteActionReason(actionReasonId: string) {
    const text = 'Are you sure you want to remove this action reason?'
    return this.confirmDialogService.confirm('Remove Action Reason', text)
      .then(() => {
        return this._deleteActionReason(actionReasonId)
      })
  }

  private _deleteActionReason(actionReasonId: string) {
    const deferred = this.$q.defer();

    this.actionReasonsRequestsService.deleteActionReason(actionReasonId)
      .then((res) => {
        this.actionReasonsAlertsService.removeSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.actionReasonsAlertsService.removeError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.action-reasons')
  .service('actionReasonsService', ActionReasonsServiceService);
